<div class="container-fluid gift-advertisement-container">
  <div class="gift-advertisement-content d-flex flex-column flex-sm-row align-items-sm-center">

    <div class="gift-advertisement-header d-flex flex-row align-items-center">
      <div class="gift-advertisement-icon me-3">
        <img class="awards-icon"
             src="assets/img/salon-consumer-awards-icon.png">
      </div>
      <div class="d-md-inline-flex">
        <h5 class="mb-0 me-2 fw-bold"
            [translate]="'HOMEPAGE.ADVERTISEMENT.TITLE-CONSUMERS-AWARDS'">
        </h5>
        <h5 class="mb-0 gift-advertisement-description">
          <a href="{{ 'HOMEPAGE.ADVERTISEMENT.LINK-CONSUMERS-AWARDS' | translate }}"
             target="_blank"
             [innerHTML]="'HOMEPAGE.ADVERTISEMENT.DESCRIPTION-CONSUMERS-AWARDS' | translate"></a>
        </h5>
      </div>
    </div>
  </div>
</div>
